export default function filter ($el, options) {
  const dropdowns = $el.querySelectorAll('select')

  dropdowns.forEach(element => {

    const paramsString = window.location.search
    const searchParams = new URLSearchParams(paramsString)
    // return modified string.
    element.addEventListener('change', function (e) {

      if (searchParams.get('page')) searchParams.delete('page')

      if (element.id === 'category') {
        searchParams.set('category', element.value)
        window.location.search = searchParams.toString()
      }
      if (element.id === 'location') {
        searchParams.set('location', element.value)
        window.location.search = searchParams.toString()
      }
    })
  })

  return () => {
    dropdowns.forEach(element => {
      element.removeEventListener('change')
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/components/filter.js